import { render } from "./ModalAcordo.vue?vue&type=template&id=687d25f8&scoped=true"
import script from "./ModalAcordo.vue?vue&type=script&lang=js"
export * from "./ModalAcordo.vue?vue&type=script&lang=js"

import "./ModalAcordo.vue?vue&type=style&index=0&id=687d25f8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687d25f8"]])

export default __exports__